<template>
  <NuxtLayout name="default" shoppingSrc="/online-shopping/cloud-callcenter/">
    <LazyHydrate when-idle>
      <ProductTopCard :details="topCardData" />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <section class="gridClass mt-16">
        <div class="text-center font-bold">
          <div class="mb-4 laptop:mb-10">
            <h2 class="text-base laptop:text-2xl">
              ویژگی‌های اصلی مرکز تماس ابری نواتل
            </h2>
          </div>
          <section class="grid grid-cols-2 laptop:grid-cols-3 gap-x-4 gap-y-10">
            <ProductAdvantage
              v-for="item in advantages"
              :key="item.id"
              :item="item"
            />
          </section>
        </div>
      </section>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <SectionSimpleText :data="simpleText" bgColor="bg-white" rounded="lg" class="!mt-16" />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <div class="gridClass mt-16">
        <ProductSecondCard :data="secondCardData" showTik />
      </div>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <section class="gridClass mt-20">
        <div class="mb-4 laptop:mb-10">
          <h3 class="text-center font-bold text-base laptop:text-2xl">
            امکانات مرکز تماس ابری نواتل
          </h3>
        </div>
        <div class="just-desktop">
          <div class="grid grid-cols-1 laptop:grid-cols-2 gap-4">
            <ProductPossibility
              v-for="item in possibilities"
              :key="item.id"
              :item="item"
            />
          </div>
        </div>
        <div class="just-mobile">
          <div class="grid grid-cols-1 laptop:grid-cols-2 gap-4">
            <ProductPossibility :item="allPossibilities" />
          </div>
        </div>
      </section>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <div id="cloudCallcenter_price" class="mt-16">
        <ProductCallcenterPlan
          :title="'بسته های مرکز تماس ابری نواتل'"
          shoppingSrc="/online-shopping/cloud-callcenter/"
        />
      </div>
    </LazyHydrate>

    <LazyHydrate when-visible>
      <SectionTable />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <h3 class="text-center text-2xl font-bold pb-6 mt-16">
        نواتل در یک نگاه
      </h3>
      <SectionPossibilities />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <ProductMoreInformation
        :details="moreInfoData"
        class="mt-10 laptop:mt-32"
      />
    </LazyHydrate>

    <LazyHydrate when-visible>
      <SectionQuestions :data="questionData" />
    </LazyHydrate>
  </NuxtLayout>
</template>

<script setup>
useHead({
  title: "مرکز تماس ابری نواتل",
  meta: [
    {
      hid: "description",
      name: "description",
      content:
        "مرکز تماس ابری, مرکز تماس,خرید مرکز تماس,مرکز ارتباط, مرکز ارتباط ابری, خدمات مرکز ارتباط, خدمات مرکز تماس, مرکز تماس نواتل, مرکز ارتباط نواتل, قیمت مرکز تماس, خرید مرکز تماس, مرکز تماس ارزان,؟ کال سنتر,کانتکت سنتر",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://navatel.ir/products/cloud-callcenter/",
    },
  ],
});

definePageMeta({
  layout: false,
});

const isModalShow = ref(false);

const isMainModalShowState = useState("isMainModalShow");

const showMainModal = () => {
  isMainModalShowState.value = true;
};

const topCardData = {
  id: "1",
  title: "مرکز تماس ابری نواتل",
  subtitle: "تجربه‌ای جذاب از ارتباطات یکپارچه",
  desc: `هر آنچه برای مدیریت مؤثر ارتباطات کسب‌وکارتان نیاز دارید، در یک پلتفرم واحد!<br />با مرکز تماس ابری نواتل، تماس‌های ورودی و خروجی را در لحظه تحلیل کنید و نحوه پاسخ‌گویی به هر یک را بررسی کنید. این داده‌ها به شما کمک می‌کنند با یک برنامه‌ریزی دقیق، کیفیت تماس‌ها را تا ۸۰٪ بهبود دهید.
 مرکز تماس ابری نواتل، تمام امکانات یک مرکز تماس پیشرفته را از طریق اینترنت در اختیار شما قرار می‌دهد؛ بدون نیاز به تجهیزات سخت‌افزاری پیچیده یا زیرساخت پرهزینه.`,
  img: "/img/product/cloudCallCenter.webp",
  // imgClass: "-mt-4",
  firstButton: {
    text: "دمو و مشاوره رایگان",
    modalId: "main",
    styleType: "primary",
  },
  secondButton: {
    text: "مشاهده قیمت‌ها",
    scrollTo: "cloudCallcenter_price",
    styleType: "secondary",
  },
};

const advantages = [
  {
    id: 0,
    title: "بدون نیاز به تجهیزات",
    text: "برای راه‌اندازی و اجرا به هیچ‌گونه تجهیزاتی نیاز ندارید. نواتل تمام زیرساخت‌ها و تجهیزات لازم را جهت ارائه بهترین کیفیت برای شما تدارک دیده است.",
    icon: "98",
  },
  {
    id: 1,
    title: "25 سال پشتیبانی قدرتمند",
    text: "با پایش و مانیتورینگ شبانه‌روزی تیم فنی نواتل در هر روز هفته، قطعی سرویس‌ها معنایی نخواهد داشت. ما پایداری ۹۹.۹۹٪ سرویس مرکز تماس ابری را تضمین می‌کنیم.",
    icon: "support",
  },
  {
    id: 2,
    title: "دورکاری با راندمان ۱۲۰ درصد!",
    text: "با قابلیت‌های گوناگون و هیجان‌انگیز مرکز تماس نواتل، امکان دورکاری و راندمان فعالیت‌های ریموت پرسنل خود را به میزان حداقل ۱۲۰ درصد افزایش دهید.",
    icon: "location-phone",
  },
  {
    id: 3,
    title: "سازمانی به وسعت کره زمین",
    text: "با مرکز تماس ابری، محدودیت جغرافیایی معنایی ندارد. در هر نقطه از کره خاکی، موقعیت جغرافیایی و در هر زمانی، تنها با اتصال به اینترنت کسب‌وکار خود را مدیریت کنید.",
    icon: "74",
  },
  {
    id: 4,
    title: "امنیت بسیار بالا",
    text: "واحد فنی نواتل با نظارت شبانه‌روزی بر وضعیت سرورها و شبکه، با تمام توان از داده‌های محرمانه کسب‌وکار شما محافظت می‌کند. تیم نواتل امنیت اطلاعات شما را تضمین می‌کند.",
    icon: "security",
  },
  {
    id: 5,
    title: "گزارش‌های حرفه‌ای و متنوع",
    text: "نواتل با ارائه گزارش‌های حرفه‌ای و متنوع در داشبورد اختصاصی خود، دغدغه مدیریت تماس، نحوه پاسخگویی پرسنل و کنترل میزان تماس مشتریان را با شما برطرف نموده است.",
    icon: "41",
  },
];

const secondCardData = {
  title: "مرکز تماس چه تفاوتی با مرکز تلفن دارد؟",
  img: "/img/product/cloudCallCenter2.webp",
  options: [
    {
      id: 1,
      text: "مرکز تماس به دلیل داشتن امکانات بیشتر، برای مجموعه‌ها و کسب‌وکارهای بزرگ‌تر با تعداد پرسنل بالا مناسب‌تر است.",
    },
    {
      id: 4,
      text: "در صورت تهیه مرکز تماس به جای مرکز تلفن، فضای ذخیره‌سازی ابری بیشتری در اختیار اپراتورهای سازمان قرار می‌گیرد.",
    },
    // {
    //   id: 3,
    //   text: "مدیریت بهینه کسب وکار، تسهیل و یکپارچه سازی ارتباطات درون و برون سازمانی و  تنوع کانال‌های ارتباط با مشتریان. ",
    // },
  ],
};

const possibilities = [
  {
    id: "1",
    list: [
      {
        text: " انتقال مکالمه بین اپراتورهای مرکز تماس و  ارسال پیام خودکار ",
        icon: "103",
      },
      {
        text: "انتخاب زبان و شخصی ‌سازی پیام خوش‌آمدگویی و آپلود لوگو ",
        icon: "96",
      },
      {
        text: "تعیین محل قرارگیری چت آنلاین در سایت و امکان ذخیره پیام‌ها",
        icon: "106",
      },
      {
        text: "قابلیت تنظیم عنوان باکس گفتگو و انتخاب رنگ تم پس زمینه",
        icon: "40",
      },
    ],
  },
  {
    id: "2",
    list: [
      {
        text: "پیش شماره برای ۳۱ استان، مکالمات ارزان و دریافت نوتیف تماس ",
        icon: "phone",
      },
      {
        text: "دایورت و کال فوروارد، هلد و ترنسفر تماس و امکان ضبط مکالمات ",
        icon: "divert",
      },
      {
        text: " تعریف صف، شیفت و ساعت‌های کاری و برخورداری از صندوق صوتی",
        icon: "50",
      },
      {
        text: "امکان کنترل آنلاین مکالمات و هم‌چنین نظرسنجی در پایان تماس",
        icon: "rating",
      },
    ],
  },
  {
    id: "3",
    list: [
      {
        text: "قابلیت‌ تعریف از چند IVR متناسب با ساعات روز و حتی چندسطحی",
        icon: "61",
      },
      {
        text: "اختصاص داخلی به اپراتورها و موسیقی دلنشین برای زمان انتظار ",
        icon: "25",
      },
      {
        text: "تعریف سناریو‌های پیچیده و امکان مکالمه مجدد با اپراتور پیشین",
        icon: "107",
      },
    ],
  },
  {
    id: "4",
    list: [
      {
        text: "دریافت فکس همزمان در ایمیل و داشبورد مدیریتی اختصاصی",
        icon: "89",
      },
      {
        text: "ارسال، دریافت و آرشیو فکس‌ها بدون نیاز به هیچ‌گونه تجهیزات ",
        icon: "98",
      },
      {
        text: "قابلیت ارسال و دریافت فکس‌ها بر روی گوشی موبایل و اپلیکیشن",
        icon: "outline-smartphone",
      },
    ],
  },
  {
    id: "5",
    list: [
      {
        text: "ارائه گزارش‌های حرفه‌ایی بر اساس KPIهای کسب و کار شما",
        icon: "41",
      },
      {
        text: "والبورد، داشبورد اختصاصی و دارای قابلیت اتصال به CRM شما",
        icon: "72",
      },
    ],
  },
  {
    id: "6",
    list: [
      {
        text: " نسخه اندروید، ویندوز و وب اپلیکیشن و امکان ویدئو کنفرانس ",
        icon: "16",
      },
      {
        text: "سیستم یکپارچه(UCaaS)، گروه و کانال و پیام رسانی سازمانی ",
        icon: "23",
      },
    ],
  },
];

const allPossibilities = computed(() => {
  const items = [];
  possibilities.forEach((element) => {
    items.push(...element.list);
  });
  return {
    id: "0",
    list: items,
  };
});

const simpleText = {
  id: 0,
  title: "چرا کسب‌وکارها به مرکز تماس ابری نیاز دارند؟",
  desc: "مرکز تماس ابری نواتل با ارائه گزارش‌دهی پیشرفته، نقش مهمی در بهبود مستمر راندمان تیم‌ها ایفا می‌کند. علاوه بر این، این سیستم به‌طور کامل با سایر ابزارهای ارتباطی یکپارچه شده است. این یکپارچگی به شما این امکان را می‌دهد که علاوه بر تماس‌های صوتی، از کانال‌های ارتباطی متنوعی همچون چت آنلاین، فکس ابری و پیامک برای مدیریت بهینه ارتباطات خود بهره‌برداری کنید.",
};

const moreInfoData = {
  id: "1",
  title: "درباره نواتل بیشتر بدانید",
  items: [
    {
      id: "1",
      text: "برون سپاری مرکز تماس یا برون سپاری مرکز تلفن",
      img: "/img/articles/cloudCallCenter1.webp",
      url: `https://navatel.ir/blog/%d8%a8%d8%b1%d9%88%d9%86-%d8%b3%d9%be%d8%a7%d8%b1%db%8c-%d9%85%d8%b1%da%a9%d8%b2-%d8%aa%d9%85%d8%a7%d8%b3/`,
    },
    {
      id: "2",
      text: "بهترین مرکز تماس چه ویژگی‌هایی دارد؟",
      img: "/img/articles/cloudCallCenter2.webp",
      url: `https://navatel.ir/blog/what-is-the-best-features-in-call-center/`,
    },
    {
      id: "3",
      text: "کال سنتر (Call Center) یا مرکز تماس چیست؟",
      img: "/img/articles/cloudCallCenter3.webp",
      url: `https://navatel.ir/blog/what-is-call-center/`,
      isShadow: true,
    },
  ],
};

const questionData = {
  title: "سؤالات متداول مرکز تماس ابری نواتل",
  items1: [
    {
      title: "امنیت سیستم‌های مرکز تماس ابری به چه صورت است؟",
      text: "واحد فنی نواتل به‌صورت شبانه‌روزی سیستم‌های مرکز تماس ابری را پایش می‌کند و به همین دلیل این سرویس از امنیت بسیار بالایی برخوردار است.",
    },
    {
      title: "آیا امکان اتصال مرکز تماس ابری به تلفن رومیزی وجود دارد؟",
      text: "بله، تلفن‌های تحت شبکه (آی پی فون) قابلیت اتصال به مرکز تماس ابری را دارند.",
    },
    {
      title: "آیا امکان پایش و کنترل وضعیت مرکز تماس وجود دارد؟",
      text: "بله، شما در پنل مدیریتی اختصاصی خود از طریق والبورد، در لحظه می‌توانید وضعیت مرکز تماس خود را رصد کنید.",
      br: true,
    },
    {
      title: "آیا می‌توان شماره مرکز تماس را به دلخواه انتخاب نمود؟",
      text: "بله، خطوط با پیش شماره 9169 هستند و شما می‌توانید 4 رقم بعدی را خود انتخاب نمایید.",
    },
  ],
  items2: [
    {
      title: "برای راه‌اندازی و خرید مرکز تماس ابری به چه تجهیزاتی نیاز داریم؟",
      text: "شما برای راه‌اندازی و خرید مرکز تماس ابری به هیچ‌گونه تجهیزاتی نیاز ندارید؛ تمامی زیرساخت‌های موردنظر توسط واحد توسعه محصول نواتل آماده شده است. برای استفاده از سرویس فقط به اینترنت احتیاج دارید.",
    },
    {
      title:
        "آیا با قطعی اینترنت بین‌الملل، در امکانات مرکز تماس ابری اختلال ایجاد می‌شود؟",
      text: "خیر. تمامی سرورهای نواتل در داخل کشور قرار دارد و قطعی اینترنت بین‌الملل تاثیری در کیفیت و امکانات سرویس‌های ما ندارد.",
    },
    {
      title:
        " امکان برنامه‌نویسی اختصاصی و اتصال ماژول‌های دیگر به سرویس مرکز تلفن اینترنتی نواتل امکان‌پذیر است؟",
      text: "بله. شما می‌توانید موارد مورد نیاز خود را به‌صورت کتبی برای واحد توسعه محصول نواتل ارسال کنید و پس از بررسی و امکان‌سنجی و تایید، سفارشتان انجام خواهد شد.",
    },
    {
      title: "امکان برقراری تماس درون سازمانی از طریق داخلی اختصاصی وجود دارد؟",
      text: "بله، با تعریف شماره داخلی اختصاصی در منوی اصلی آی وی آر برای شماره اپراتور، امکان برقراری تماس درون سازمانی با آن شماره داخلی وجود دارد.",
    },
  ],
};
</script>
